import { createTheme } from '@mui/material/styles';
import { ruRU, enUS, ukUA } from '@mui/material/locale';
import { ruRU as pickersRuRU } from '@mui/x-date-pickers/locales';
import { enUS as pickersEnUS } from '@mui/x-date-pickers/locales';
import { ukUA as pickersUkUA } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';

// Import dayjs locales
import 'dayjs/locale/ru';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/uk';

// Import dayjs plugins
import updateLocale from 'dayjs/plugin/updateLocale';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);

/**
 * Get Material-UI locale based on language code
 */
export const getMuiLocale = (language: string) => {
  switch (language) {
    case 'ru':
      return ruRU;
    case 'uk':
      return ukUA;
    case 'en':
    default:
      return enUS;
  }
};

/**
 * Get dayjs locale code based on i18n language
 */
export const getDayjsLocale = (language: string): string => {
  switch (language) {
    case 'ru':
      return 'ru';
    case 'uk':
      return 'uk';
    case 'en':
    default:
      return 'en-gb';
  }
};

/**
 * Set dayjs locale globally
 */
export const setDayjsLocale = (language: string) => {
  const locale = getDayjsLocale(language);
  dayjs.locale(locale);
};

/**
 * Create localized theme
 */
export const createLocalizedTheme = (baseTheme: any, language: string) => {
  const muiLocale = getMuiLocale(language);
  return createTheme(baseTheme, muiLocale);
};

/**
 * Get MUI x-date-pickers localeText based on language
 */
export const getPickersLocaleText = (language: string) => {
  switch (language) {
    case 'ru':
      return pickersRuRU.components.MuiLocalizationProvider.defaultProps.localeText;
    case 'uk':
      return {
        ...pickersUkUA.components.MuiLocalizationProvider.defaultProps.localeText,
        fieldYearPlaceholder: (params: { digitAmount: number }) => 'Р'.repeat(params.digitAmount),
        fieldMonthPlaceholder: (params: { contentType: string }) => params.contentType === 'letter' ? 'ММММ' : 'ММ',
        fieldDayPlaceholder: () => 'ДД',
        fieldHoursPlaceholder: () => 'гг',
        fieldMinutesPlaceholder: () => 'хх',
        fieldSecondsPlaceholder: () => 'сс',
      };
    case 'en':
    default:
      return pickersEnUS.components.MuiLocalizationProvider.defaultProps.localeText;
  }
};

export default {
  getMuiLocale,
  getDayjsLocale,
  setDayjsLocale,
  createLocalizedTheme,
  getPickersLocaleText,
};